import { SVGProps } from 'react';

const SvgHandSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M8.264 1.5c-.35 0-.648.29-.648.667v5.055a.5.5 0 0 1-1 0v-3.5a.657.657 0 0 0-.647-.666c-.35 0-.647.29-.647.666v.002l-.014 3.499.004 2.055h-.004v.666a.5.5 0 0 1-.856.35l-1.51-1.536a.85.85 0 0 0-1.148-.065.81.81 0 0 0-.14 1.099l2.642 3.649A2.543 2.543 0 0 0 6.355 14.5h4.572c1.406 0 2.56-1.161 2.56-2.611V9.056h.005L13.5 4.5a.657.657 0 0 0-.647-.667c-.35 0-.648.29-.648.667v2.722a.5.5 0 1 1-1 0V2.944a.657.657 0 0 0-.647-.666c-.35 0-.647.29-.647.666v4.278a.5.5 0 1 1-1 0V2.167a.657.657 0 0 0-.647-.667Zm1.502-.017A1.645 1.645 0 0 0 8.264.5c-.918 0-1.648.754-1.648 1.667v.022a1.626 1.626 0 0 0-.647-.133c-.917 0-1.647.753-1.647 1.665v.696-.695m0 0v1.39l-.014 3.61-.652-.664a1.85 1.85 0 0 0-2.493-.141 1.81 1.81 0 0 0-.32 2.461l2.643 3.65A3.543 3.543 0 0 0 6.355 15.5h4.572c1.974 0 3.56-1.625 3.56-3.611v-1.833h.003L14.5 4.5c0-.913-.73-1.668-1.647-1.668-.23 0-.45.048-.648.134v-.023c0-.912-.73-1.666-1.647-1.666-.288 0-.558.074-.792.205"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgHandSmall;
